import React, { useState } from 'react';
import Input from '../../components/UI/CustomInputField';
import Layout from '../../components/Layout/Layout';
import Button from '../../components/UI/Button/index';
import { isValidEmail } from '../../helpers';
import { useUser, useUserDispatchers } from '../../state/user';
import css from './ParentInvite.module.scss';

type ParentInviteWithEmailProps = {
  onParentInvite: (parentEmail?: string) => void;
};
const ParentInviteWithEmail = (props: ParentInviteWithEmailProps) => {
  const [parentEmail, setParentEmail] = useState('');
  const { setNextRegStep } = useUserDispatchers();
  const { userIsTeen } = useUser();

  const header = userIsTeen
    ? 'Invite your parent to get a Greenlight card'
    : 'You’ll need a parent to start using Greenlight';
  const subHeader = userIsTeen
    ? 'You’ll need a parent or guardian to set up a Greenlight debit card. Invite them by entering their email address.'
    : 'Invite your parent or guardian to create your Greenlight account by entering their email address.';

  const onChange = value => {
    setParentEmail(value);
  };

  const onSubmit = () => {
    if (isValidEmail(parentEmail)) {
      props.onParentInvite(parentEmail);
    }

    setNextRegStep(userIsTeen ? 'validate' : 'parent_invite_complete');
  };

  return (
    <Layout data-e2e="parent-invite-container">
      <div className={css.ParentInviteMainBox} data-e2e="need-adult">
        <h1 data-e2e="need-adult-header">{header}</h1>
        <p data-e2e="need-adult-legal">{subHeader}</p>
      </div>
      <Input
        id="parent-email-input"
        placeholder="Parent or guardian’s email address"
        value={parentEmail}
        autoComplete="off"
        autoCorrect="off"
        inputMode="text"
        onInput={onChange}
        data-e2e="email"
        format={''}
      />
      <Button text="Next" disabled={!isValidEmail(parentEmail) || parentEmail.trim() === ''} onClick={onSubmit} />
    </Layout>
  );
};

export default ParentInviteWithEmail;
